module.exports = __webpack_public_path__ + "img/dot-pattern.9eeafaef.svg";